module.exports = __webpack_public_path__ + "img/06.443cb2bb.jpg";